import { FilterMatchMode } from "primereact/api";

export class NivelPerfil {
    model = {
        id: {
            value: null,
            export: false
        },
        nombre: {
            value: '',
            header: 'Nombre',
            required: 'Campo requerido',
            maxLength: 'Máximo 300 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 300,
            min: 4,
            filterField: 'nombre',
            table: true,
            filter: true,
            sort: true,
            matchMode: FilterMatchMode.CONTAINS
        },
        detalle: {
            value: '',
            header: 'Detalle',
            required: 'Campo requerido',
            maxLength: 'Máximo 300 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 300,
            min: 4,
        },
        codigo: {
            value: '',
            header: 'Código',
            required: 'Campo requerido',
            maxLength: 'Máximo 50 caracteres',
            minLength: 'Mínimo 4 caracteres',
            table: true,
            max: 100,
            min: 4,
            filter: true,
            filterField: 'codigo',
            matchMode: FilterMatchMode.CONTAINS
        },
        fecha_inicio: {
            value: null,
            header: 'Fecha de inicio',
            required: 'Campo requerido',
            maxLength: 'Máximo 100 caracteres',
            minLength: 'Mínimo 1 caracteres',
            table: true,
            max: 100,
            min: 1,
        },
        fecha_fin: {
            header: 'Fecha de fin',
            value: null,
            required: 'fecha es requerido',
            optionLabel: 'empresa',
            export: true,
            table: true
        },
        apetito_inherente: {
            value: null,
            header: 'Apetito Inherente',
            required: 'Campo requerido',
            type: 'number',
            min: 0,
            max: 5,
            table: false
        },
        tolerancia_inherente: {
            value: null,
            header: 'Tolerancia Inherente',
            required: 'Campo requerido',
            type: 'number',
            min: 0,
            max: 5,
            table: false
        },
        apetito_residual: {
            value: null,
            header: 'Apetito Residual',
            required: 'Campo requerido',
            type: 'number',
            min: 0,
            max: 5,
            table: false
        },
        tolerancia_residual: {
            value: null,
            header: 'Tolerancia Residual',
            required: 'Campo requerido',
            type: 'number',
            min: 0,
            max: 5,
            table: false
        },
        estado: {
            value: '',
            header: 'Estado',
            table: true,
            filter: true,
            filterField: 'estado',
            matchMode: FilterMatchMode.CONTAINS,
            headerStyle: { width: '175px' }
        },
    }
    optionLabel = 'nombre';
    header = [
        [
            { text: 'Fecha', rowSpan: 2, style: 'th' },
            { text: 'Identificación', rowSpan: 2, style: 'th' },
            { text: 'Nombre / Razón Social', rowSpan: 2, style: 'th' },
            { text: 'Factores de Riesgo (puntaje)', colSpan: 4, style: 'th' }, {}, {}, {},
            { text: 'Desviación factor acelerador', colSpan: 5, style: 'th' }, {}, {}, {}, {},
            { text: 'Alerta factores', rowSpan: 2, style: 'th' },
            { text: 'Calificación del Riesgo inherente', rowSpan: 2, style: 'th' },
            { text: 'Nivel de Riesgo Inherente', rowSpan: 2, style: 'th' },
            { text: 'Promedio Calificación del Riesgo del periodo seleccionado', rowSpan: 2, style: 'th' },
            { text: 'Nivel de riesgo del periodo seleccionado', rowSpan: 2, style: 'th' },
            { text: 'Alerta apetito de riesgo inherente', rowSpan: 2, style: 'th' },
            { text: 'Alerta tolerancia de riesgo inherente', rowSpan: 2, style: 'th' },
            { text: 'Procedimiento (Control) Recomendado', rowSpan: 2, style: 'th' },
            { text: 'Procedimiento (Control) Aplicado', rowSpan: 2, style: 'th' },
            { text: 'Alerta Procedimiento Aplicado', rowSpan: 2, style: 'th' },
            { text: 'Calificación del Riesgo residual', rowSpan: 2, style: 'th' },
            { text: 'Nivel de Riesgo residual', rowSpan: 2, style: 'th' },
            { text: 'Promedio Calificación del Riesgo del periodo seleccionado', rowSpan: 2, style: 'th' },
            { text: 'Nivel de riesgo del periodo seleccionado', rowSpan: 2, style: 'th' },
            { text: 'Alerta apetito de riesgo residual', rowSpan: 2, style: 'th' },
            { text: 'Alerta tolerancia de riesgo residual', rowSpan: 2, style: 'th' },
            { text: 'SE JUSTIFICÓ LA ALERTA', rowSpan: 2, style: 'th' },
        ],
        [
            {}, {}, {},
            { text: 'Cliente', style: 'th' },
            { text: 'Producto', style: 'th' },
            { text: 'Transacción', style: 'th' },
            { text: 'Factor Acelerador', style: 'th' },
            { text: 'Desviación cliente', style: 'th' },
            { text: 'Desviación producto', style: 'th' },
            { text: 'Desviación transacción', style: 'th' },
            { text: 'Desviación acelerador', style: 'th' },
            { text: 'Promedio desviaciones', style: 'th' },
        ]
    ];
    template = (body, info) => {
        return {
            pageOrientation: 'landscape',
            pageSize: 'A2',
            pageMargins: [40, 80, 40, 40],
            header: {
                margin: [40, 20, 40, 20],
                columns: [
                    info.logo
                        ? { image: info.logo, width: 80, alignment: 'left', margin: [0, 0, 10, 0] }
                        : { text: '', width: 80, alignment: 'left', margin: [0, 0, 10, 0] },
                    {
                        stack: [
                            { text: 'Monitoreo Nivel Riesgos Perfil', style: 'header' },
                            { text: info.razon_social, style: 'subtitle' },
                            {
                                text: [
                                    { text: 'Periodo Analizado: ', bold: true },
                                    { text: `Desde ${info.fecha_inicio} hasta ${info.fecha_fin}` }
                                ], style: 'periodo'
                            },
                        ],
                        width: '*'
                    },
                    { text: '', width: 80, alignment: 'right', margin: [0, 0, 0, 10] }
                ]
            },
            footer: (currentPage, pageCount) => ({
                columns: [
                    {
                        stack: [
                            {
                                text: [
                                    { text: 'Fecha de creación del monitoreo: ', bold: true },
                                    { text: info.fecha_creacion }
                                ],
                                fontSize: 8,
                                margin: [0, 0, 0, 2],
                                alignment: 'left'
                            },
                            {
                                text: [
                                    { text: 'Fecha de generación del reporte: ', bold: true },
                                    { text: info.fecha_generacion }
                                ],
                                fontSize: 8,
                                alignment: 'left'
                            }
                        ],
                        width: '33%'
                    },
                    { text: `Página ${currentPage} de ${pageCount}`, alignment: 'center', fontSize: 9, width: '34%' },
                    { text: `Estado de monitoreo: ${info.estado}`, alignment: 'right', fontSize: 9, width: '33%' }
                ],
                margin: [40, 10, 40, 0]
            }),
            content: [
                {
                    table: {
                        widths: ['*', '*', '*'],
                        body: [
                            [
                                { text: 'Nombre del Monitoreo', style: 'th', fillColor: '#e0e0e0' },
                                { text: 'Código de referencia', style: 'th', fillColor: '#e0e0e0' },
                                { text: 'Detalle del monitoreo', style: 'th', fillColor: '#e0e0e0' }
                            ],
                            [
                                { text: info.nombre, style: 'td' },
                                { text: info.codigo, style: 'td' },
                                { text: info.detalle, style: 'td' }
                            ]
                        ]
                    },
                    layout: {
                        hLineColor: '#ccc',
                        vLineColor: '#ccc',
                        paddingLeft: () => 6,
                        paddingRight: () => 6,
                    },
                    margin: [0, 0, 0, 15] //espacio debajo de la tabla
                },
                {
                    table: {
                        widths: ['*', '*', '*', '*'],
                        body: [
                            [
                                { text: 'NIVEL(ES) DE RIESGO INHERENTE ACEPTADO', style: 'th', colSpan: 2, fillColor: '#e0e0e0' }, {},
                                { text: 'NIVEL(ES) DE RIESGO RESIDUAL ACEPTADO', style: 'th', colSpan: 2, fillColor: '#e0e0e0' }, {}
                            ],
                            [
                                { text: 'APETITO', style: 'th', fillColor: '#eeeeee' },
                                { text: 'TOLERANCIA', style: 'th', fillColor: '#eeeeee' },
                                { text: 'APETITO', style: 'th', fillColor: '#eeeeee' },
                                { text: 'TOLERANCIA', style: 'th', fillColor: '#eeeeee' }
                            ],
                            [
                                { text: info.apetito_inherente, bold: true, fontSize: 10, fillColor: '#f9f9f9' },
                                { text: info.tolerancia_inherente, bold: true, fontSize: 10, fillColor: '#f9f9f9' },
                                { text: info.apetito_residual, bold: true, fontSize: 10, fillColor: '#f9f9f9' },
                                { text: info.tolerancia_residual, bold: true, fontSize: 10, fillColor: '#f9f9f9' }
                            ]
                        ]
                    },
                    layout: {
                        hLineColor: '#ccc',
                        vLineColor: '#ccc',
                        paddingLeft: () => 4,
                        paddingRight: () => 4
                    },
                    margin: [0, 0, 0, 15] // espacio debajo de la tabla
                },
                {
                    table: {
                        headerRows: 2,
                        body: body,
                    },
                    layout: {
                        fillColor: function (rowIndex, node, columnIndex) {
                            return null;
                        },
                        hLineColor: '#ccc',
                        vLineColor: '#ccc',
                        paddingLeft: () => 4,
                        paddingRight: () => 4,
                    }
                }
            ],
            styles: {
                header: { fontSize: 16, bold: true, alignment: 'center', color: '#003366', margin: [0, 0, 0, 5] },
                th: { bold: true, fontSize: 9, alignment: 'center', fillColor: '#eeeeee' },
                td: { fontSize: 9, alignment: 'center' },
                subtitle: { fontSize: 12, bold: true, color: '#003366', margin: [0, 0, 0, 5] },
                periodo: { fontSize: 9, italics: true, color: '#222' },
            },
            defaultStyle: {
                alignment: 'center',
                fontSize: 7
            }
        }
    }
}
